// extracted by mini-css-extract-plugin
export default {"timeReturned":"timeReturned---RJcpg"};